// Independently implemented controls. Native Horizon owns product variants, search and cart editing.
// Header is custom, so explicitly bridge close controls to Horizon's drawer API.
document.addEventListener('click',event=>{const button=event.target.closest('.theme-drawer__close-button');if(button){const drawer=button.closest('theme-drawer');if(typeof drawer?.close==='function')drawer.close();}});
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
function setupSportHomeHero(slider) {
  slider.dataset.spReady = 'true';
  const slides = Array.from(slider.querySelectorAll('[data-sp-slide]'));
  if (!slides.length) return;
  const counter = slider.querySelector('[data-sp-current]');
  const progress = slider.querySelector('[data-sp-progress]');
  const pauseButton = slider.querySelector('[data-sp-pause]');
  const interval = Number(slider.dataset.interval) || 5000;
  const speed = reducedMotion ? 0 : 1400;
  const easing = 'cubic-bezier(.16,1,.3,1)';
  const events = new AbortController();
  const held = new Set();
  let index = 0;
  let paused = reducedMotion;
  let timer = 0;
  let settling = 0;
  let frame = 0;
  let progressFrame = 0;
  let animating = false;
  let gesture = null;
  let touchCount = 0;
  let suppressClick = false;
  let destroyed = false;
  const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: events.signal });
  const wrap = value => (value + slides.length) % slides.length;
  const pose = (slide, side, amount = 1, duration = 0) => {
    const previous = side === 'previous';
    const distance = side === 'center' ? 0 : (previous ? -30 : 104) * amount;
    const rotation = side === 'center' ? 0 : (previous ? -2 : 2) * amount;
    const scale = side === 'center' ? 1 : 1 + (previous ? .17 : .04) * amount;
    const depth = previous ? -amount : 0;
    slide.style.transition = duration ? 'transform ' + duration + 'ms ' + easing : 'none';
    slide.style.transform = 'translate3d(0,' + distance + '%,' + depth + 'px) rotate(' + rotation + 'deg) scale(' + scale + ')';
  };
  const markActive = () => {
    slides.forEach((slide, position) => {
      const active = position === index;
      slide.classList.toggle('is-active', active);
      slide.classList.remove('is-previous');
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');
  };
  const rest = () => {
    markActive();
    slides.forEach((slide, position) => {
      slide.style.zIndex = position === index ? '3' : '0';
      pose(slide, position === index ? 'center' : 'next');
    });
  };
  const clearAutoplay = () => {
    clearTimeout(timer);
    cancelAnimationFrame(progressFrame);
    if (progress) {
      progress.style.transition = 'none';
      progress.style.width = '0%';
    }
  };
  const schedule = () => {
    clearAutoplay();
    if (destroyed || paused || animating || held.size || touchCount || document.hidden || slides.length < 2) return;
    progressFrame = requestAnimationFrame(() => { progressFrame = requestAnimationFrame(() => {
      if (paused || animating || held.size || touchCount || document.hidden || destroyed) return;
      if (progress) {
        progress.style.transition = 'width ' + interval + 'ms linear';
        progress.style.width = '100%';
      }
    }); });
    timer = setTimeout(() => move(1), interval);
  };
  const finish = () => {
    clearTimeout(settling);
    cancelAnimationFrame(frame);
    animating = false;
    slider.dataset.transitioning = 'false';
    slider.classList.remove('is-dragging');
    rest();
    schedule();
  };
  const settle = (direction, commit, staged = false) => {
    clearAutoplay();
    const outgoing = slides[index];
    const incoming = slides[wrap(index + direction)];
    if (outgoing === incoming) return schedule();
    if (!staged) {
      pose(outgoing, 'center');
      pose(incoming, direction > 0 ? 'next' : 'previous');
      outgoing.style.zIndex = '2';
      incoming.style.zIndex = '3';
      void incoming.offsetWidth;
    }
    animating = true;
    slider.dataset.transitioning = 'true';
    slider.classList.remove('is-dragging');
    if (commit) {
      index = wrap(index + direction);
      markActive();
    }
    const complete = () => {
      if (commit) {
        pose(outgoing, direction > 0 ? 'previous' : 'next', 1, speed);
        pose(incoming, 'center', 1, speed);
      } else {
        pose(outgoing, 'center', 1, speed);
        pose(incoming, direction > 0 ? 'next' : 'previous', 1, speed);
      }
      if (!speed) finish();
      else settling = setTimeout(finish, speed);
    };
    if (!speed || staged) complete();
    else frame = requestAnimationFrame(complete);
  };
  const move = direction => {
    if (destroyed || animating || held.size || touchCount || slides.length < 2) return;
    settle(direction, true);
  };
  const updatePause = () => {
    if (!pauseButton) return;
    pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    pauseButton.setAttribute('aria-pressed', String(paused));
  };
  listen(slider.querySelector('[data-sp-prev]'), 'click', () => move(-1));
  listen(slider.querySelector('[data-sp-next]'), 'click', () => move(1));
  if (pauseButton) listen(pauseButton, 'click', () => {
    paused = !paused;
    updatePause();
    schedule();
  });
  listen(slider, 'keydown', event => {
    if (event.target.closest('input,select,textarea') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    move(event.key === 'ArrowRight' ? 1 : -1);
  });
  listen(slider, 'dragstart', event => event.preventDefault());
  listen(slider, 'click', event => {
    if (!suppressClick) return;
    if (event.target.closest('.sp-slider-controls')) {
      suppressClick = false;
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, { capture: true });
  listen(slider, 'pointerdown', event => {
    if (event.button !== 0 || event.target.closest('button,a,input,select,textarea') || animating) return;
    suppressClick = false;
    held.add(event.pointerId);
    clearAutoplay();
    if (gesture) return;
    gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, started: performance.now(), axis: '', direction: 1, progress: 0 };
  });
  listen(slider, 'pointermove', event => {
    if (!gesture || event.pointerId !== gesture.id || held.size > 1) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (!gesture.axis) {
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
      gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (gesture.axis === 'x') {
        slider.setPointerCapture(event.pointerId);
        slider.classList.add('is-dragging');
        suppressClick = true;
      }
    }
    if (gesture.axis !== 'x') return;
    event.preventDefault();
    gesture.direction = dx < 0 ? 1 : -1;
    gesture.progress = Math.min(1, Math.abs(dx) / Math.max(1, slider.clientWidth));
    const outgoing = slides[index];
    const incoming = slides[wrap(index + gesture.direction)];
    outgoing.style.zIndex = '2';
    incoming.style.zIndex = '3';
    if (!reducedMotion) {
      pose(outgoing, gesture.direction > 0 ? 'previous' : 'next', gesture.progress);
      pose(incoming, gesture.direction > 0 ? 'next' : 'previous', 1 - gesture.progress);
    }
  }, { passive: false });
  const release = (event, cancelled = false) => {
    const wasHeld = held.delete(event.pointerId);
    if (!gesture || event.pointerId !== gesture.id) {
      if (wasHeld) schedule();
      return;
    }
    const ended = gesture;
    gesture = null;
    if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
    if (ended.axis === 'x') {
      const shortSwipe = performance.now() - ended.started < 300;
      const commit = !cancelled && (shortSwipe ? ended.progress * slider.clientWidth >= 6 : ended.progress >= .5);
      settle(ended.direction, commit, true);
    } else schedule();
  };
  listen(window, 'pointerup', event => release(event));
  listen(window, 'pointercancel', event => release(event, true));
  listen(slider, 'lostpointercapture', event => {
    if (gesture?.id === event.pointerId) release(event, true);
  });
  listen(slider, 'touchstart', event => {
    touchCount = event.touches.length;
    clearAutoplay();
  }, { passive: true });
  const releaseTouch = event => {
    touchCount = event.touches.length;
    if (!touchCount) schedule();
  };
  listen(window, 'touchend', releaseTouch, { passive: true });
  listen(window, 'touchcancel', releaseTouch, { passive: true });
  listen(document, 'visibilitychange', () => {
    held.clear();
    gesture = null;
    touchCount = 0;
    if (animating) finish();
    else {
      rest();
      schedule();
    }
  });
  listen(window, 'resize', () => {
    held.clear();
    gesture = null;
    touchCount = 0;
    if (animating) finish();
    else {
      slider.classList.remove('is-dragging');
      rest();
      schedule();
    }
  });
  listen(document, 'shopify:section:unload', event => {
    if (!event.target.contains(slider)) return;
    destroyed = true;
    clearAutoplay();
    clearTimeout(settling);
    cancelAnimationFrame(frame);
    events.abort();
  });
  updatePause();
  rest();
  schedule();
}


function setupSport(root=document){
 root.querySelectorAll('[data-sp-slider]:not([data-sp-ready])').forEach(slider=>{
  if(slider.hasAttribute('data-sp-home-hero')){setupSportHomeHero(slider);return;}
  slider.dataset.spReady='true';const slides=[...slider.querySelectorAll('[data-sp-slide]')];let index=0,timer,paused=reducedMotion;const duration=Number(slider.dataset.interval)||8000;const progress=slider.querySelector('[data-sp-progress]');
  const schedule=()=>{clearTimeout(timer);if(progress){progress.style.transition='none';progress.style.width='0';requestAnimationFrame(()=>requestAnimationFrame(()=>{if(!paused){progress.style.transition=`width ${duration}ms linear`;progress.style.width='100%';}}));}if(!paused&&slides.length>1)timer=setTimeout(()=>select(index+1),duration);};
  const select=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.classList.toggle('is-previous',i===(index-1+slides.length)%slides.length);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;slide.querySelectorAll('video').forEach(v=>active&&!reducedMotion?v.play().catch(()=>{}):v.pause());});const counter=slider.querySelector('[data-sp-current]');if(counter)counter.textContent=String(index+1).padStart(2,'0');schedule();};
  slider.querySelector('[data-sp-prev]')?.addEventListener('click',()=>select(index-1));slider.querySelector('[data-sp-next]')?.addEventListener('click',()=>select(index+1));slider.querySelector('[data-sp-pause]')?.addEventListener('click',e=>{paused=!paused;e.currentTarget.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');e.currentTarget.setAttribute('aria-pressed',String(paused));schedule();});
  slider.addEventListener('focusin',()=>{clearTimeout(timer);if(progress)progress.style.transition='none';});slider.addEventListener('focusout',schedule);let touchX=0;slider.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;},{passive:true});slider.addEventListener('touchend',e=>{const distance=e.changedTouches[0].clientX-touchX;if(Math.abs(distance)>50)select(index+(distance<0?1:-1));},{passive:true});select(0);
 });
 root.querySelectorAll('[data-sp-tabs]:not([data-sp-ready])').forEach(section=>{section.dataset.spReady='true';const buttons=[...section.querySelectorAll('[data-sp-tab]')];buttons.forEach((button,index)=>{button.addEventListener('click',()=>{buttons.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-selected',String(b===button));});section.querySelectorAll('.sp-product').forEach(card=>card.hidden=button.dataset.spTab!=='all'&&card.dataset.spCategory!==button.dataset.spTab);section.querySelector('[data-sp-rail]').scrollLeft=0;});button.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft'].includes(e.key)){e.preventDefault();const next=buttons[(index+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length];next.focus();next.click();}});});});
 root.querySelectorAll('[data-sp-rail]:not([data-sp-ready])').forEach(rail=>{rail.dataset.spReady='true';if(rail.closest('rk-collection-carousel'))return;const section=rail.closest('section');section.querySelector('[data-sp-rail-prev]')?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.8,behavior:reducedMotion?'instant':'smooth'}));section.querySelector('[data-sp-rail-next]')?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.8,behavior:reducedMotion?'instant':'smooth'}));const update=()=>{const line=section.querySelector('.sp-rail-track i');if(line){const size=Math.min(100,rail.clientWidth/rail.scrollWidth*100);line.style.width=`${size}%`;line.style.marginLeft=`${(rail.scrollLeft/Math.max(1,rail.scrollWidth-rail.clientWidth))*(100-size)}%`;}};rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();});
}
setupSport();document.addEventListener('shopify:section:load',e=>setupSport(e.target));
document.addEventListener('click',e=>{const opener=e.target.closest('[data-sp-open]');if(opener){const dialog=document.getElementById(opener.dataset.spOpen);dialog?.showModal();opener.setAttribute('aria-expanded','true');dialog?.addEventListener('close',()=>{opener.setAttribute('aria-expanded','false');opener.focus();},{once:true});}if(e.target.closest('[data-sp-close]'))e.target.closest('dialog')?.close();if(e.target.closest('#SportMenu a'))e.target.closest('dialog')?.close();if(e.target instanceof HTMLDialogElement){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}});
const header=document.querySelector('[data-sport-header]');if(header){let lastY=0;let pending=false;const scroller=document.querySelector('.page-wrapper');const updateHeader=()=>{pending=false;const current=document.querySelector('[data-sport-header]');if(!current)return;const y=Math.max(scroller?.scrollTop||0,window.scrollY||0);current.classList.toggle('is-sticky',current.classList.contains('sp-header--overlay')?y>16:y>120&&y<lastY);lastY=y;};const onHeaderScroll=()=>{if(!pending){pending=true;requestAnimationFrame(updateHeader);}};window.addEventListener('scroll',onHeaderScroll,{passive:true});scroller?.addEventListener('scroll',onHeaderScroll,{passive:true});window.addEventListener('pageshow',updateHeader);document.addEventListener('shopify:section:load',updateHeader);updateHeader();}
let quickDialog;
function getQuickDialog(){if(!quickDialog){quickDialog=document.createElement('dialog');quickDialog.className='sp-quick-dialog';quickDialog.setAttribute('aria-label','Product quick view');document.body.append(quickDialog);}return quickDialog;}
async function loadQuick(url){const dialog=getQuickDialog();dialog.innerHTML='<p class="sp-loading" role="status">Loading product…</p>';if(!dialog.open)dialog.showModal();const target=new URL(url,location.origin);target.searchParams.set('section_id','rk-sport-quick');const response=await fetch(target);if(!response.ok)throw new Error('Unable to load this product.');const html=await response.text();if(!html.includes('data-sp-quick-form'))throw new Error('Unable to load this product.');dialog.innerHTML=`<button class="sp-icon-button sp-quick-close" data-sp-close aria-label="Close quick view">${document.querySelector('#SportMenu [data-sp-close]').innerHTML}</button>${html}`;const form=dialog.querySelector('[data-sp-quick-form]');form.dataset.spProductUrl=url.split('?')[0];dialog.querySelector('[data-sp-close]').focus();}
document.addEventListener('click',async e=>{const button=e.target.closest('[data-sp-quick]');if(!button)return;try{await loadQuick(button.dataset.spQuick);}catch(error){getQuickDialog().innerHTML='<p class="sp-loading" role="alert">Unable to open quick view. Please use the product link.</p><button class="sp-button" data-sp-close>Close</button>';}});
document.addEventListener('change',async e=>{if(!e.target.matches('[data-sp-quick-form] select[name="id"]'))return;const form=e.target.closest('form');try{await loadQuick(`${form.dataset.spProductUrl}?variant=${encodeURIComponent(e.target.value)}`);}catch(error){form.querySelector('[data-sp-quick-status]').textContent='Please open the product page to select this option.';}});
document.addEventListener('submit',async e=>{const form=e.target.closest('[data-sp-quick-form]');if(!form)return;e.preventDefault();const button=form.querySelector('[type="submit"]'),status=form.querySelector('[data-sp-quick-status]');button.disabled=true;status.textContent='Adding to your bag…';try{const data=new FormData(form);data.append('sections','cart-drawer-section');data.append('sections_url',location.pathname);const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',body:data,headers:{Accept:'application/json'}});const added=await response.json();if(!response.ok)throw new Error(added.description||'This item could not be added.');const html=added.sections?.['cart-drawer-section'];if(!html){location.assign(`${window.Shopify?.routes?.root||'/'}cart`);return;}const parsed=new DOMParser().parseFromString(html,'text/html');const newSection=parsed.getElementById('shopify-section-cart-drawer-section');const current=document.getElementById('shopify-section-cart-drawer-section');if(!current||!newSection){location.assign(`${window.Shopify?.routes?.root||'/'}cart`);return;}current.replaceChildren(...newSection.childNodes);const cartResponse=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`);const cart=await cartResponse.json();document.querySelectorAll('.cart-bubble__text-count').forEach(count=>count.textContent=cart.item_count||'');quickDialog.close();await customElements.whenDefined('theme-drawer');requestAnimationFrame(()=>document.getElementById('cart-drawer')?.open());}catch(error){status.textContent=error.message;button.disabled=false;}});
let sportZoomDialog;
document.addEventListener('click',event=>{
 const target=event.target;
 const hotspot=target.closest('[data-sp-hotspot]');
 if(hotspot){const section=hotspot.closest('[data-sp-hotspots]'),index=hotspot.dataset.spHotspot;section.querySelectorAll('[data-sp-hotspot]').forEach(b=>{b.classList.toggle('is-active',b.dataset.spHotspot===index);b.setAttribute('aria-pressed',String(b.dataset.spHotspot===index));});section.querySelectorAll('[data-sp-hotspot-photo]').forEach(p=>p.classList.toggle('is-active',p.dataset.spHotspotPhoto===index));section.querySelectorAll('[data-sp-hotspot-item]').forEach(p=>p.classList.toggle('is-active',p.dataset.spHotspotItem===index));}
 const zoom=target.closest('[data-sp-gallery-zoom]');
 if(zoom){if(!sportZoomDialog){sportZoomDialog=document.createElement('dialog');sportZoomDialog.className='sp-zoom-dialog';sportZoomDialog.setAttribute('aria-label','Product image');document.body.append(sportZoomDialog);}sportZoomDialog.innerHTML=`<button class="sp-icon-button" data-sp-close aria-label="Close">${document.querySelector('#SportMenu [data-sp-close]').innerHTML}</button><div class="sp-angle">${zoom.innerHTML}</div>`;sportZoomDialog.showModal();sportZoomDialog.addEventListener('close',()=>zoom.focus(),{once:true});}
 const dot=target.closest('[data-sp-angle]');
 if(dot){
  const gallery=dot.closest('media-gallery');
  if(gallery.hasAttribute('data-sp-thumbnail-gallery')){
   gallery.querySelectorAll('[data-sp-gallery-view]').forEach(view=>{view.hidden=view.dataset.spGalleryView!==dot.dataset.spAngle;});
   gallery.querySelectorAll('[data-sp-angle]').forEach(button=>{const active=button===dot;button.setAttribute('aria-current',String(active));button.setAttribute('aria-pressed',String(active));});
  }
 }
 const toggle=target.closest('[data-sp-video-toggle]');
 if(toggle){const video=toggle.closest('.sp-media-card').querySelector('video');const update=(playing)=>{toggle.setAttribute('aria-label',playing?'Pause video':'Play video');toggle.setAttribute('aria-pressed',String(playing));toggle.querySelector('[data-sp-video-play-icon]').hidden=playing;toggle.querySelector('[data-sp-video-pause-icon]').hidden=!playing;};if(video.paused){video.play().then(()=>update(true)).catch(()=>update(false));}else{video.pause();update(false);}}
 const mute=target.closest('[data-sp-video-mute]');
 if(mute){const video=mute.closest('.sp-media-card').querySelector('video');video.muted=!video.muted;mute.setAttribute('aria-label',video.muted?'Unmute video':'Mute video');mute.setAttribute('aria-pressed',String(!video.muted));}
});

document.addEventListener('click',event=>{const tab=event.target.closest('[data-sp-view-tab]');if(tab){const group=tab.closest('[data-sp-view-panels]'),index=tab.dataset.spViewTab;group.querySelectorAll('details').forEach(d=>{if(d!==tab.closest('details'))d.open=false;});group.querySelectorAll('[data-sp-view-photo]').forEach(p=>p.classList.toggle('is-active',p.dataset.spViewPhoto===index));}const options=event.target.closest('[data-sp-product-options]');if(options){event.preventDefault();document.querySelector('.product-details variant-picker')?.scrollIntoView({behavior:reducedMotion?'instant':'smooth',block:'start'});}});





